import React from "react";

export function ChecklistSkeleton() {
    return (
        <div className="max-w-4xl w-full mx-auto pb-12 animate-pulse">
            <div className="flex items-center justify-between mb-2">
                <div>
                    <div className="h-4 w-36 bg-tm-gray-200 rounded"/>

                    <div className="h-3 w-52 bg-tm-gray-200 rounded mt-1.5"/>
                </div>

                <div className="text-right">
                    <div className="h-3 w-20 bg-tm-gray-200 rounded mb-1 ml-auto"/>

                    <div className="h-4 w-8 bg-tm-gray-200 rounded ml-auto"/>
                </div>
            </div>

            <div className="w-full h-1 bg-tm-gray-200 rounded-full mb-5"/>

            <div className="flex flex-col gap-2.5">
                <div className="bg-inverse rounded-2xl shadow-sm">
                    <div className="flex items-center justify-between px-6 py-4">
                        <div className="flex items-center gap-3">
                            <div className="w-6 h-6 rounded-full bg-tm-gray-200 shrink-0"/>

                            <div className="h-3.5 w-48 bg-tm-gray-200 rounded"/>
                        </div>

                        <div className="h-5 w-16 bg-tm-gray-200 rounded-full"/>
                    </div>
                </div>

                <div className="bg-inverse rounded-2xl shadow-sm">
                    <div className="flex items-center justify-between px-6 py-4">
                        <div className="flex items-center gap-3">
                            <div className="w-6 h-6 rounded-full bg-tm-gray-200 shrink-0"/>

                            <div className="h-3.5 w-36 bg-tm-gray-200 rounded"/>
                        </div>

                        <div className="h-5 w-20 bg-tm-gray-200 rounded-full"/>
                    </div>
                </div>

                <div className="bg-inverse rounded-2xl shadow-sm">
                    <div className="flex items-center justify-between px-6 py-4">
                        <div className="flex items-center gap-3">
                            <div className="w-6 h-6 rounded-full bg-tm-gray-200 shrink-0"/>

                            <div className="h-3.5 w-56 bg-tm-gray-200 rounded"/>
                        </div>

                        <div className="h-5 w-14 bg-tm-gray-200 rounded-full"/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default function ChecklistProgress({title, total, completed, waiting, progress, isLoading}) {
    if (isLoading) {
        return <ChecklistSkeleton />
    }

    return (
        <div className="pb-6">
            <div className="flex items-center justify-between mb-2">
                <div>
                    <p className="text-sm font-medium text-tm-gray-800">{title}</p>

                    <p className="text-xs text-tm-gray-600 mt-0.5">{total} steps · {completed} completed
                        · {waiting} waiting</p>
                </div>

                <div className="text-right">
                    <p className="text-xs text-tm-gray-600 mb-1">Overall progress</p>

                    <p className="text-sm font-medium text-emerald-600">{progress}%</p>
                </div>
            </div>

            <div className="relative w-full h-1 bg-tm-gray-300 rounded-full overflow-hidden">
                <div className="absolute inset-y-0 left-0 bg-amber-400 rounded-full transition-all duration-500"
                     style={{width: `${total > 0 ? Math.round(((completed + waiting) / total) * 100) : 0}%`}}/>

                <div className="absolute inset-y-0 left-0 bg-emerald-500 rounded-full transition-all duration-500"
                     style={{width: `${progress}%`}}/>
            </div>
        </div>
    );
}
